function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "TankStrapping",
  transform: "translate(-335 -391)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1895",
  "data-name": "Group 1895",
  transform: "translate(344 396)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1624",
  "data-name": "Group 1624"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_434",
  d: "M.32 0h5.128a.321.321 0 01.32.32v10.9a.32.32 0 01-.641 0V.641H.641V1.6A.32.32 0 110 1.6V.32A.321.321 0 01.32 0zm0 2.884A.32.32 0 110 3.2a.321.321 0 01.32-.316zm0 1.6a.321.321 0 01.32.32v9.934h4.487v-.32a.32.32 0 01.641 0v.641a.321.321 0 01-.32.32H.32a.321.321 0 01-.32-.32V4.807a.321.321 0 01.32-.321zM5.448 12.5a.32.32 0 11-.32.32.321.321 0 01.32-.32z",
  className: "cls-2",
  "data-name": "Path 434"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1625",
  "data-name": "Group 1625"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_435",
  d: "M.32 0H1.6a.321.321 0 01.32.32v14.741a.32.32 0 11-.641 0V.641H.641v12.5a.32.32 0 01-.641 0V.32A.321.321 0 01.32 0zm0 14.42a.32.32 0 11-.32.32.321.321 0 01.32-.32z",
  className: "cls-2",
  "data-name": "Path 435"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1626",
  "data-name": "Group 1626",
  transform: "translate(3.525 13.779)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_436",
  d: "M.32 0h1.6a.32.32 0 010 .641H.32A.32.32 0 01.32 0z",
  className: "cls-2",
  "data-name": "Path 436"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1627",
  "data-name": "Group 1627",
  transform: "translate(4.166 12.498)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_437",
  d: "M.32 0h.961a.32.32 0 110 .641H.32A.32.32 0 11.32 0z",
  className: "cls-2",
  "data-name": "Path 437"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1628",
  "data-name": "Group 1628",
  transform: "translate(3.525 11.216)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_438",
  d: "M.32 0h1.6a.32.32 0 010 .641H.32A.32.32 0 01.32 0z",
  className: "cls-2",
  "data-name": "Path 438"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1629",
  "data-name": "Group 1629",
  transform: "translate(4.166 9.934)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_439",
  d: "M.32 0h.961a.32.32 0 010 .641H.32A.32.32 0 01.32 0z",
  className: "cls-2",
  "data-name": "Path 439"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1630",
  "data-name": "Group 1630",
  transform: "translate(3.525 8.652)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_440",
  d: "M.32 0h1.6a.32.32 0 010 .641H.32A.32.32 0 01.32 0z",
  className: "cls-2",
  "data-name": "Path 440"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1631",
  "data-name": "Group 1631",
  transform: "translate(4.166 7.37)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_441",
  d: "M.32 0h.961a.32.32 0 010 .641H.32A.32.32 0 01.32 0z",
  className: "cls-2",
  "data-name": "Path 441"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1632",
  "data-name": "Group 1632",
  transform: "translate(3.525 6.089)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_442",
  d: "M.32 0h1.6a.32.32 0 110 .641H.32A.32.32 0 11.32 0z",
  className: "cls-2",
  "data-name": "Path 442"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1633",
  "data-name": "Group 1633",
  transform: "translate(4.166 4.807)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_443",
  d: "M.32 0h.961a.32.32 0 110 .641H.32A.32.32 0 11.32 0z",
  className: "cls-2",
  "data-name": "Path 443"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1634",
  "data-name": "Group 1634",
  transform: "translate(3.525 3.525)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_444",
  d: "M.32 0h1.6a.32.32 0 110 .641H.32A.32.32 0 11.32 0z",
  className: "cls-2",
  "data-name": "Path 444"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1635",
  "data-name": "Group 1635",
  transform: "translate(4.166 2.243)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_445",
  d: "M.32 0h.961a.32.32 0 110 .641H.32A.32.32 0 11.32 0z",
  className: "cls-2",
  "data-name": "Path 445"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1636",
  "data-name": "Group 1636",
  transform: "translate(3.525 .961)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_446",
  d: "M.32 0h1.6a.32.32 0 010 .641H.32A.32.32 0 01.32 0z",
  className: "cls-2",
  "data-name": "Path 446"
}))));

var SvgTankStrapping = function SvgTankStrapping(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTankStrapping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tank-strapping.45383c00.svg";
export { ForwardRef as ReactComponent };